export default "__VITE_ASSET__wGyAwocZ__"